import { Button, CircularProgress, Fab, styled } from "@mui/material";
import { green } from "@mui/material/colors";
import { useFormikContext } from "formik";
import { useEffect, useState, FC } from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import { Box } from "@mui/system";

interface ICreateButton {
  disabled: boolean;
}

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  border: "1px solid #0060aa",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
  "&:disabled": {
    backgroundColor: "#5d7fc9 !important",
    border: "1px solid #5d7fc9",
  },
});

const EditButton: FC<ICreateButton> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik: any = useFormikContext();
  let [, setPrompt] = useState<boolean>(formik.dirty);
  const [success, setSuccess] = useState<boolean>(false);

  // usePrompt(t("actions.are_you_sure_leave"), isPrompt);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
  };

  useEffect(() => {
    setPrompt(formik.dirty);
    if (disabled) setPrompt(false);
    if (formik.isSubmitting) {
      setSuccess(false);
    } else {
      setSuccess(true);
    }
  }, [formik.dirty, disabled, formik.isSubmitting]);

  return (
    <>
      {formik.isSubmitting ? (
        <Box sx={{ m: 1, position: "relative" }}>
          <Fab aria-label="save" sx={buttonSx} disabled>
            {success ? <CheckIcon /> : <SaveIcon />}
          </Fab>
          <CircularProgress
            size={68}
            sx={{
              color: green[500],
              position: "absolute",
              top: -6,
              left: "47%",
              zIndex: 1,
            }}
          />
        </Box>
      ) : (
        <BootstrapButton
          className="btn btn-default"
          type="submit"
          disabled={!formik.dirty || disabled}
          sx={buttonSx}
          style={{ minWidth: "200px" }}
        >
          {formik.isSubmitting ? (
            <CircularProgress
              size={30}
              sx={{
                color: "#43168b",
                top: "-50%",
                left: "-50%",
                zIndex: 1,
                transform: "translate(50%, 50%)",
              }}
            />
          ) : (
            t("actions.update")
          )}
        </BootstrapButton>
      )}
    </>
  );
};
export default EditButton;
